import styles from './ResentCode.module.scss';

export const ResendCode = ({ onResend }: { onResend: () => void}) => {
  return (
    <>
      <p className={styles.resentCode}>
        Didn’t receive a code? <span onClick={onResend}>Resend code</span>
      </p>
    </>
  );
};

export const ResetPhoneSignIn = ({ changePhoneCallback }: { changePhoneCallback: () => void }) => {
  return (
    <>
      <p className={styles.resentCode}>
       Don’t have access to your phone? <span onClick={changePhoneCallback}>Reset phone number</span>
      </p>
    </>
  );
}

export const ResetPhone = ({ phone, changePhoneCallback }: { phone: string, changePhoneCallback: () => void }) => {
  return (
    <>
      <p className={styles.resentCode}>
        Check your messages. Code is sent to:
      </p>
      <p className={styles.resentCode}>
        +1 {phone} <span onClick={changePhoneCallback}>(Change phone number)</span>
      </p>
    </>
  );
}
